<template>
  <div>
    <div style="background-color:#FDE2DF;padding:10px">
      <el-form ref="form" :rules="rules" :model="dataForm" label-position="top" style="text-align:left">
        <div ref="name"></div>
        <!-- ZDANOVACIE OBDOBIE -->
        <el-row :gutter="10">
          <!-- MESIAC -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item prop="tax_period_month" :rules="[{ required: true, message: $t('webformtaxpay.msg.tax_period_month') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.tax_period_month')}}</span>
              <el-select
                v-model="dataForm.tax_period_month"
                :placeholder="$t('webformtaxpay.msg.tax_period')"
                style="width:100%"
              >
                <el-option v-for="month in tax_period_date_month"
                  :key="month.value" :label="month.label" :value="month.value">
                </el-option>
              </el-select>
              <div style="margin-top:-5px;margin-left:5px;color:#F56C6C;font-size:14px;font-weight: bold;">{{$t('webformtaxpay.msg.tax_period_desc')}}</div>
            </el-form-item>
          </el-col>
          <!-- ROK -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item prop="tax_period_year" :rules="[{ required: true, message: $t('webformtaxpay.msg.tax_period') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.tax_period_year')}}</span>
              <el-select
                v-model="dataForm.tax_period_year"
                clearable
                :placeholder="$t('webformtaxpay.msg.tax_period')"
                style="width:100%"
                @change="dataForm.tax_period_month = ''"
              >
                <el-option v-for="year in tax_period_date_year"
                  :key="year" :label="year" :value="year">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- NAZEV PLATCE DANE -->
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item prop="payer_name">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.payer_name')}}</span>
                <el-input
                  v-model="dataForm.payer_name"
                  clearable
                  readonly
                  :placeholder="$t('webformtaxpay.msg.payer_name')"
                  style="width:100%"
                >
                </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- ADRESA PLATCE DANE -->
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item prop="payer_address">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.payer_address')}}</span>
                <el-input
                  v-model="dataForm.payer_address"
                  clearable
                  readonly
                  :placeholder="$t('webformtaxpay.msg.payer_address')"
                  style="width:100%"
                >
                </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Identifikacia poplatnika: MENO -->
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item prop="taxpayer_firstname" :rules="[{ required: true, message: $t('webformtaxpay.msg.val_taxpayer_firstname') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.taxpayer_firstname')}}</span>
                <el-input
                  v-model="dataForm.taxpayer_firstname"
                  clearable
                  :placeholder="$t('webformtaxpay.msg.taxpayer_firstname')"
                  style="width:100%"
                >
                </el-input>
            </el-form-item>
          </el-col>
          <!-- Identifikacia poplatnika: PRIEZVISKO -->
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item prop="taxpayer_surname" :rules="[{ required: true, message: $t('webformtaxpay.msg.val_taxpayer_surname') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.taxpayer_surname')}}</span>
                <el-input
                  v-model="dataForm.taxpayer_surname"
                  clearable
                  :placeholder="$t('webformtaxpay.msg.taxpayer_surname')"
                  style="width:100%"
                >
                </el-input>
            </el-form-item>
          </el-col>
          <!-- Identifikacia poplatnika: RODNE CISLO -->
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item prop="taxpayer_birth_nr" :rules="[{ required: true, message: $t('webformtaxpay.msg.val_taxpayer_birth_nr') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.taxpayer_birth_nr')}}</span>
                <el-input
                  v-model="dataForm.taxpayer_birth_nr"
                  clearable
                  :placeholder="$t('webformtaxpay.msg.taxpayer_birth_nr')"
                  style="width:100%"
                >
                </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Identifikacia poplatnika: BYDLISKO -->
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item prop="taxpayer_address" :rules="[{ required: true, message: $t('webformtaxpay.msg.val_taxpayer_address') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.taxpayer_address')}}</span>
              <google-address
                code="address"
                @complete="fillAddress"
                :placeholder="$t('webformtaxpay.msg.taxpayer_address')"
                :search.sync="dataForm.taxpayer_address"
                :options="{style: 'margin-bottom:10px;width:100%'}">
              </google-address>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- JE DAŇOVY NEREZIDENT? -->
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item>
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.msg.is_resident')}}
                <el-tooltip placement="top" effect="light">
                  <i class="far fa-question-circle tool-tip-form"></i>
                  <div slot="content">{{$t('webformtaxpay.msg.hint_resident')}}</div>
                </el-tooltip>
              </span>
                <el-switch
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  v-model="dataForm.is_resident"
                  active-text="Áno jsem rezident"
                  inactive-text="Ne nejsem rezident"
                >
                </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="!dataForm.is_resident">
          <!-- Daňový nerezident: DATUM NARODENIA  -->
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item prop="resident_birth_date" :rules="[{ required: !dataForm.is_resident, message: $t('webformtaxpay.msg.val_not_resident') }]">
                <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.resident_birth_date')}}</span>
                  <el-date-picker
                    v-model="dataForm.resident_birth_date"
                    format="dd.MM.yyyy"
                    type="date"
                    :placeholder="$t('webformtaxpay.lbl.resident_birth_date')"
                    style="width:100%"
                  >
                  </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <!-- Daňový nerezident: ČÍSLO A TYP DOKLADU  -->
            <el-col :xs="24" :sm="24" :md="12" :lg="14" :xl="14">
              <el-form-item prop="resident_document_number" :rules="[{ required: !dataForm.is_resident, message: $t('webformtaxpay.msg.val_not_resident') }]">
                <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.resident_document_number')}}</span>
                  <el-input
                    v-model="dataForm.resident_document_number"
                    :placeholder="$t('webformtaxpay.msg.resident_document_number')"
                  >
                  </el-input>
              </el-form-item>
            </el-col>
            <!-- Daňový nerezident: STÁT  -->
            <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
              <el-form-item prop="resident_document_country" :rules="[{ required: !dataForm.is_resident, message: $t('webformtaxpay.msg.val_not_resident') }]">
                <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.resident_document_country')}}</span>
                  <el-input
                    v-model="dataForm.resident_document_country"
                    :placeholder="$t('webformtaxpay.lbl.resident_document_country')"
                  >
                  </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <!-- Daňový nerezident: IDENTIFIKACE  -->
            <el-col :xs="24" :sm="24" :md="12" :lg="14" :xl="14">
              <el-form-item prop="resident_identification" :rules="[{ required: !dataForm.is_resident, message: $t('webformtaxpay.msg.val_not_resident') }]">
                <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.resident_identification')}}</span>
                  <el-input
                    v-model="dataForm.resident_identification"
                    :placeholder="$t('webformtaxpay.msg.resident_identification')"
                  >
                  </el-input>
              </el-form-item>
            </el-col>
            <!-- Daňový nerezident: STÁT  -->
            <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="10">
              <el-form-item prop="resident_country" :rules="[{ required: !dataForm.is_resident, message: $t('webformtaxpay.msg.val_not_resident') }]">
                <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.resident_country')}}</span>
                  <el-input
                    v-model="dataForm.resident_country"
                    :placeholder="$t('webformtaxpay.lbl.resident_country')"
                  >
                  </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- podle §35ba odst1 -->
        <el-row :gutter="10">
          <span style="color:#5F6266;font-size:20px">{{$t('webformtaxpay.lbl.title_35ba1')}}</span>
          <div style="margin-top:-5px;color:#F56C6C;font-size:14px;font-weight: bold;">{{$t('webformtaxpay.msg.title_35ba1_desc')}}</div>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item>
              <el-checkbox-group v-model="dataForm.discount" size="small">
                <div class="item_check">
                  <el-checkbox :label="1">{{$t('webformtaxpay.msg.discount1')}}</el-checkbox>
                </div>
                <div class="item_check">
                  <el-checkbox :label="2">{{$t('webformtaxpay.msg.discount2')}}</el-checkbox>
                  <div class="item_check_desc">
                    {{$t('webformtaxpay.msg.discount2_desc')}}
                    <div v-if="dataForm.discount.includes(2)" style="color:#F56C6C;font-size:16px;margin-top:10px;font-weight: bold;">{{$t('webformtaxpay.msg.discount2_d_desc')}}</div>
                  </div>
                </div>
                <div class="item_check">
                  <el-checkbox :label="3">{{$t('webformtaxpay.msg.discount3')}}</el-checkbox>
                  <div class="item_check_desc">
                    {{$t('webformtaxpay.msg.discount3_desc')}}
                    <div v-if="dataForm.discount.includes(3)" style="color:#F56C6C;font-size:16px;margin-top:10px;font-weight: bold;">{{$t('webformtaxpay.msg.discount3_d_desc')}}</div>
                  </div>
                </div>
                <div class="item_check">
                  <el-checkbox :label="4">{{$t('webformtaxpay.msg.discount4')}}</el-checkbox>
                  <div class="item_check_desc">
                    {{$t('webformtaxpay.msg.discount4_desc')}}
                    <div v-if="dataForm.discount.includes(4)" style="color:#F56C6C;font-size:16px;margin-top:10px;font-weight: bold;">{{$t('webformtaxpay.msg.discount4_d_desc')}}</div>
                  </div>
                </div>
                <div class="item_check">
                  <el-checkbox :label="5">{{$t('webformtaxpay.msg.discount5')}}</el-checkbox>
                  <div class="item_check_desc">
                    {{$t('webformtaxpay.msg.discount5_desc')}}
                    <div v-if="dataForm.discount.includes(5)" style="color:#F56C6C;font-size:16px;margin-top:10px;font-weight: bold;">{{$t('webformtaxpay.msg.discount5_d_desc')}}</div>
                  </div>
                </div>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Podle § 35c a § 35d zákona uplatňuji / dodatečně uplatňuji5) daňové zvýhodnění3) -->
        <!-- <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item>
              <h3 slot="label" class="hm-cell">{{$t('webformtaxpay.msg.is_benefits_for_children')}}</h3>
                <el-switch
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  v-model="dataForm.is_benefits_for_children"
                  active-text="dodatečně uplatňuji"
                >
                </el-switch>
            </el-form-item>
          </el-col>
        </el-row> -->
        <span style="color:#5F6266;font-size:20px">{{$t('webformtaxpay.msg.is_benefits_for_children')}}
          <el-tooltip placement="top" effect="light">
            <i class="far fa-question-circle tool-tip-form" style="font-size:14px"></i>
            <div slot="content">{{$t('webformtaxpay.msg.hint_benefits')}}</div>
          </el-tooltip>
        </span>
        <div style="margin-top:-5px;color:#F56C6C;font-size:14px;font-weight: bold;">{{$t('webformtaxpay.msg.title_35c35d_desc')}}</div>
        <div
          v-for="(child, index) in dataForm.benefits_for_children"
          :key="index"
          style="padding: 0px"
        >
          <el-row :gutter="3">
            <!-- FIRSTNAME -->
            <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
              <el-form-item>
                <span v-if="index === 0" slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.firstname')}}</span>
                <el-input
                  v-model="dataForm.benefits_for_children[index].firstname"
                  clearable
                  :placeholder="$t('webformtaxpay.lbl.firstname')"
                  style="width:100%"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- SURNAME -->
            <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
              <el-form-item>
                <span v-if="index === 0" slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.surname')}}</span>
                <el-input
                  v-model="dataForm.benefits_for_children[index].surname"
                  clearable
                  :placeholder="$t('webformtaxpay.lbl.surname')"
                  style="width:100%"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- RODNE CISLO -->
            <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
              <el-form-item>
                <span v-if="index === 0" slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.birth_nr')}}</span>
                  <el-input
                    v-model="dataForm.benefits_for_children[index].birth_nr"
                    clearable
                    :placeholder="$t('webformtaxpay.lbl.birth_nr')"
                    style="width:100%"
                  >
                  </el-input>
              </el-form-item>
            </el-col>
            <!-- Uplatňuji/neuplatňujinárok ve výši na -->
            <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
              <el-form-item>
                <span v-if="index === 0" slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.discount')}}</span>
                <el-select
                  v-model="dataForm.benefits_for_children[index].claim"
                  clearable
                  style="width:100%"
                >
                  <el-option v-for="claim in optClaim"
                    :key="claim" :label="claim" :value="claim">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- ZTP/P -->
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              <el-form-item>
                <span v-if="index === 0" slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.ztpp')}}</span>
                <el-select
                  v-model="dataForm.benefits_for_children[index].is_ztpp"
                  clearable
                  style="width:100%"
                >
                  <el-option v-for="discount in optDiscount"
                    :key="discount.label" :label="discount.label" :value="discount.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- Zletile dite -->
            <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
              <el-form-item>
                <span v-if="index === 0" slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.baby_dite')}}</span>
                <el-select
                  v-model="dataForm.benefits_for_children[index].is_baby_dite"
                  clearable
                  style="width:100%"
                >
                  <el-option v-for="discount in optDiscount"
                    :key="discount.label" :label="discount.label" :value="discount.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- Dodatecne za kal. mesiace -->
            <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
              <el-form-item>
                <span v-if="index === 0" slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.additionally')}}</span>
                <el-input
                  v-model="dataForm.benefits_for_children[index].additionally"
                  clearable
                  style="width:100%"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="width:100%;text-align:right;padding:0px;">
            <el-button type="text" @click="dataForm.benefits_for_children.splice(index, 1)" v-if="dataForm.benefits_for_children.length -1  > 0">Odstranit dítě</el-button>
            <el-button type="text" @click="dataForm.benefits_for_children.push({})" v-if="index === dataForm.benefits_for_children.length - 1 && dataForm.benefits_for_children.length - 1 < 4">Přidat dítě</el-button>
          </div>
        </div>
        <!-- Podle § 38k odst. 4 zákona prohlašuji, že: -->
        <el-row :gutter="10">
          <span style="color:#5F6266;font-size:20px">{{$t('webformtaxpay.lbl.title_38k4')}}</span>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item>
              <el-switch
                active-color="#13ce66"
                inactive-color="#ff4949"
                v-model="dataForm.is_other_taxpayer"
                active-text="v rámci téže společně hospodařící domácnosti vyživuje tytéž mnou vyživované děti i jiný poplatník"
              >
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="3" v-if="dataForm.is_other_taxpayer">
          <div style="margin-top:-5px;color:#F56C6C;font-size:14px;font-weight: bold;">{{$t('webformtaxpay.msg.title_other_taxpayer')}}</div>
          <!-- FIRSTNAME -->
          <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
            <el-form-item prop="other_taxpayer.firstname" :rules="[{ required: dataForm.is_other_taxpayer, message: $t('webformtaxpay.msg.val_must_fill') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.firstname')}}</span>
              <el-input
                v-model="dataForm.other_taxpayer.firstname"
                clearable
                :placeholder="$t('webformtaxpay.lbl.firstname')"
                style="width:100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <!-- SURNAME -->
          <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
            <el-form-item prop="other_taxpayer.surname" :rules="[{ required: dataForm.is_other_taxpayer, message: $t('webformtaxpay.msg.val_must_fill') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.surname')}}</span>
              <el-input
                v-model="dataForm.other_taxpayer.surname"
                clearable
                :placeholder="$t('webformtaxpay.lbl.surname')"
                style="width:100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <!-- RODNE CISLO -->
          <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
            <el-form-item prop="other_taxpayer.birth_nr" :rules="[{ required: dataForm.is_other_taxpayer, message: $t('webformtaxpay.msg.val_must_fill') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.birth_nr')}}</span>
                <el-input
                  v-model="dataForm.other_taxpayer.birth_nr"
                  clearable
                  :placeholder="$t('webformtaxpay.lbl.birth_nr')"
                  style="width:100%"
                >
                </el-input>
            </el-form-item>
          </el-col>
          <!-- Adresa bydliska -->
          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
            <el-form-item prop="other_taxpayer.address" :rules="[{ required: dataForm.is_other_taxpayer, message: $t('webformtaxpay.msg.val_must_fill') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.address')}}</span>
              <!-- <el-input
                v-model="dataForm.other_taxpayer.address"
                clearable
                style="width:100%"
              >
              </el-input> -->
              <google-address
                code="address"
                @complete="fillAddress1"
                :placeholder="$t('webformtaxpay.msg.taxpayer_address')"
                :search.sync="dataForm.other_taxpayer.address"
                :options="{style: 'margin-bottom:10px;width:100%'}">
              </google-address>
            </el-form-item>
          </el-col>
          <!-- Uplatňuje danove zvyhodnenie -->
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
            <el-form-item prop="other_taxpayer.is_discount_applies" :rules="[{ required: dataForm.is_other_taxpayer, message: $t('webformtaxpay.msg.val_must_fill') }]">
              <span slot="label" class="hm-cell">
                {{$t('webformtaxpay.lbl.is_discount_applies')}}
                <el-tooltip placement="top" effect="light">
                  <i class="far fa-question-circle tool-tip-form"></i>
                  <div slot="content">{{$t('webformtaxpay.msg.hint_discount_applies')}}</div>
                </el-tooltip>
              </span>
              <el-select
                v-model="dataForm.other_taxpayer.is_discount_applies"
                clearable
                style="width:100%"
              >
                <el-option v-for="discount in optDiscount"
                  :key="discount.label" :label="discount.label" :value="discount.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- Zamestnanie -->
          <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
            <el-form-item prop="other_taxpayer.is_employment" :rules="[{ required: dataForm.is_other_taxpayer, message: $t('webformtaxpay.msg.val_must_fill') }]">
              <span slot="label" class="hm-cell">
                {{$t('webformtaxpay.lbl.is_employment')}}
                <el-tooltip placement="top" effect="light">
                  <i class="far fa-question-circle tool-tip-form"></i>
                  <div slot="content">{{$t('webformtaxpay.msg.hint_employment')}}</div>
                </el-tooltip>
              </span>
              <el-select
                v-model="dataForm.other_taxpayer.is_employment"
                clearable
                style="width:100%"
              >
                <el-option v-for="discount in optDiscount"
                  :key="discount.label" :label="discount.label" :value="discount.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- Název plátce dane -->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="dataForm.other_taxpayer.is_employment">
            <el-form-item prop="other_taxpayer.payer_name" :rules="[{ required: dataForm.is_other_taxpayer, message: $t('webformtaxpay.msg.val_must_fill') }]">
              <span slot="label" class="hm-cell">
                {{$t('webformtaxpay.lbl.payer_name')}}
                <el-tooltip placement="top" effect="light">
                  <i class="far fa-question-circle tool-tip-form"></i>
                  <div slot="content">{{$t('webformtaxpay.msg.hint_payer_name')}}</div>
                </el-tooltip>
              </span>
              <el-input
                v-model="dataForm.other_taxpayer.payer_name"
                clearable
                style="width:100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <!-- Adresa plátce dane -->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="dataForm.other_taxpayer.is_employment">
            <el-form-item prop="other_taxpayer.payer_address" :rules="[{ required: dataForm.is_other_taxpayer, message: $t('webformtaxpay.msg.val_must_fill') }]">
              <span slot="label" class="hm-cell">{{$t('webformtaxpay.lbl.payer_address')}}</span>
              <google-address
                code="address"
                @complete="fillAddress2"
                :placeholder="$t('webformtaxpay.msg.taxpayer_address')"
                :search.sync="dataForm.other_taxpayer.payer_address"
                :options="{style: 'margin-bottom:10px;width:100%'}">
              </google-address>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- SLOTs -->
    <slot name="upload"></slot>
    <!-- BUTTONs -->
    <div style="margin-top:10px;margin-bottom:20px">
      <el-row>
        <el-col :xs="24" :sm="8" :md="8" style="float:right;">
          <el-button
            style="width:100%"
            type="success"
            @click="saveForm"
          >Potvrzuji mnou zadané údaje</el-button>
        </el-col>
        <el-col :xs="24" :sm="16" :md="16">&nbsp;</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable brace-style */
/* eslint-disable one-var */
/* eslint-disable standard/object-curly-even-spacing */
import GoogleAddress from '@/components/HMGoogleAddress/index.vue'

export default {
  props: ['dataForm', 'optData'],
  name: 'TaxPayForm',
  components: {
    'google-address': GoogleAddress
  },
  data () {
    return {
      tax_period_date_year: [],
      tax_period_date_month: [],
      optDiscount: [
        { label: 'ANO', value: true },
        { label: 'NE', value: false }
      ],
      optClaim: ['1.', '2.', '3.', 'N.'],
      rules: {

      }
    }
  },
  watch: {
    'dataForm.tax_period_month': function () {
      this.dataForm.tax_period = this.dataForm.tax_period_month + '/' + this.dataForm.tax_period_year
    },
    'dataForm.tax_period_year': function () {
      this.taxPeriodDateMonth()
      this.dataForm.tax_period = this.dataForm.tax_period_month + '/' + this.dataForm.tax_period_year
    }
  },
  created () {
    this.$moment.locale('cs')
    this.taxPeriodDateYear()
    this.taxPeriodDateMonth()
    if (!this.dataForm.tax_period) {
      let current_date = new Date() // this.$moment('2024/12/10')
      this.dataForm.tax_period_month = this.$moment(current_date).format('MM')
      this.dataForm.tax_period_year = this.$moment(current_date).format('YYYY')
    } else {
      let tmp = this.dataForm.tax_period.split('/')
      this.dataForm.tax_period_year = tmp[1]
      this.dataForm.tax_period_month = tmp[0].length === 1 ? '0' + tmp[0] : tmp[0]
    }
    this.dataForm.tax_period = this.dataForm.tax_period_month + '/' + this.dataForm.tax_period_year
  },
  methods: {
    taxPeriodDateYear () { // napln combo
      /**
       * A) v januari zobrazis 2 moznosti -> sucasny rok a minuly rok
       * B) v decembri zobrazis 2 moznosti -> sucasny rok a buduci rok
       * C) vo feb - novembri -> vzdy iba sucasny rok
       */
      let current_date = new Date() // this.$moment('2024/12/10')
      let current_year = parseInt(this.$moment(current_date).format('YYYY'))
      let current_month = parseInt(this.$moment(current_date).format('MM'))
      let min_year = current_year
      let max_year = current_year
      switch (current_month) {
        case 1: // januar
          min_year--
          break
        case 12: // december
          max_year++
          break
        default: // februar - november
          // nerob nic, zobraz iba aktualny rok
      }
      this.tax_period_date_year = []
      for (let year = min_year; year < max_year + 1; year++) {
        this.tax_period_date_year.push(year)
      }
    },
    taxPeriodDateMonth () { // napln combo
      /**
      * A) jeden mesiac dozadu, od akutalneho mesiaca
      * B) akutalny mesiac v roku
      * C) zvysne mesiace v roku
      * ---
      * priklad.
      *  pre datum 7.1.2022 bude kombo roky -> 2021, 2022
      *   pre rok 2021 bude iba 12 mesiac
      *   pre rok 2022 budu vsetky mesiace
      *  pre datum. 10.5.2024 bude kombo roky iba 2024
      *   a mesiace budu 4-12
      *   pre datum 20.12.2023 -> bude kombo roky obsahovat 2023, 2024
      *   pre rok 2023 bude kombo mesiace -> 11,12
      *   pre rok 2024 -> 1 - 12
      *  cize v januari kazdeho roku zobrazis za predchadzajuci rok vzdy iba mesiac december na vyber
      */
      let current_date = new Date()
      let current_year = parseInt(this.$moment(current_date).format('YYYY'))
      let current_month = parseInt(this.$moment(current_date).format('MM'))
      let min_month = current_month
      let max_month = current_month
      switch (true) {
        case this.dataForm.tax_period_year === current_year - 1:
          min_month = 12
          max_month = 12
          break
        case ((this.dataForm.tax_period_year === current_year) && (current_month === 12)):
          min_month--
          max_month = 12
          break
        case this.dataForm.tax_period_year === current_year + 1:
          min_month = 1
          max_month = 12
          break
        default:
          console.log('default => min_month', min_month)
          min_month = min_month > 1 ? (min_month - 1) : min_month
          console.log('default => new min_month', min_month)
          max_month = 12
      }
      this.tax_period_date_month = []
      for (let month = min_month; month <= max_month; month++) {
        let cur_date = this.$moment().startOf('year')
        this.tax_period_date_month.push({label: this.$moment(cur_date).add(parseInt(month - 1), 'month').format('MMMM'), value: this.$moment(cur_date).add(month - 1, 'month').format('MM')})
      }
    },
    /**
     *  odstrani polia, ktore tam nemaju byt...
     *    priklad1:  zafajknem ze nie som rezident, rozbalia sa polia, ktore teda musim vyplnit, po vyplneni, vsak zistim, ze vlastne rezident som, 
     *              takze odfajknem, ze som rezident, ale fieldy ako resident_birth_date, resident_document_number tam zostanu vyplnene... (malo pripadov ze to niekto takto vyplni ale stava sa to)
     *    priklad2: zafajknem paragraf 38, a tam vyskoci: Vyplnte udaje druheho rodice, tak zacnem vyplnem, firstname, pak si uvedomim, 
     *              ze toto nevyplnujem, vymazem firstname a odfajknem paragraf ale other_taxpayer.firstname: '' <-- uz zostane vyplnene, niekolkokrat sa stalo
     */
    handleDataToSend() {
      if (this.dataForm.is_other_taxpayer === false) { // v rámci téže společně hospodařící domácnosti NEvyživuje tytéž mnou vyživované děti i jiný poplatník
        this.dataForm.other_taxpayer = {} // proste prazdny object!
      }
      if (this.dataForm.is_resident === true) { // Áno jsem rezident... tak tieto fieldy tam nemaju co hladat
        delete this.dataForm.resident_birth_date // datum narodenia
        delete this.dataForm.resident_document_number // cislo a typ dokladu (obciansky preukaz)
        delete this.dataForm.resident_document_country // stat, ktory tento doklad vydal
        delete this.dataForm.resident_identification // identifikacia pre danove ucely v state kde je danovym rezidentom
        delete this.dataForm.resident_country // stat, kde je rezident 
      }
      // deti - odstran prazdne riadky atd...
      for (let index = 0; index < this.dataForm.benefits_for_children.length; index++) {
        const child = this.dataForm.benefits_for_children[index]
        if (child.is_ztpp === '') {
          delete this.dataForm.benefits_for_children[index].is_ztpp
        }
        if (child.is_baby_dite === '') {
          delete this.dataForm.benefits_for_children[index].is_baby_dite
        }
      }
    },
    saveForm () {
      this.handleDataToSend()
      // console.log('dataForm ==>', this.dataForm)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('save', this.dataForm)
        } else {
          this.$notify({
            title: 'Upozornění',
            message: 'Zkontrolujte pole označená hvězdičkou. Tato pole je nutno vyplnit!',
            type: 'warning',
            duration: 5000
          })
          window.scrollTo({
            top: 100,
            left: 0,
            behavior: 'smooth'
          })
        }
      })
    },
    fillAddress (p_obj) {
      if (!p_obj) return
      // ---
      let street = p_obj.street ? p_obj.street : ''
      street = p_obj.street_number ? street + ' ' + p_obj.street_number : street
      let postal_code = p_obj.postal_code ? p_obj.postal_code : ''
      postal_code = street.length > 0 ? ', ' + postal_code : postal_code
      let city = p_obj.city ? p_obj.city : ''
      city = p_obj.postal_code.length > 0 ? ', ' + city : city
      this.dataForm.taxpayer_address = street + postal_code + city
    },
    fillAddress1 (p_obj) {
      if (!p_obj) return
      // ---
      let street = p_obj.street ? p_obj.street : ''
      street = p_obj.street_number ? street + ' ' + p_obj.street_number : street
      let postal_code = p_obj.postal_code ? p_obj.postal_code : ''
      postal_code = street.length > 0 ? ', ' + postal_code : postal_code
      let city = p_obj.city ? p_obj.city : ''
      city = p_obj.postal_code.length > 0 ? ', ' + city : city
      this.dataForm.other_taxpayer.address = street + postal_code + city
    },
    fillAddress2 (p_obj) {
      if (!p_obj) return
      // ---
      let street = p_obj.street ? p_obj.street : ''
      street = p_obj.street_number ? street + ' ' + p_obj.street_number : street
      let postal_code = p_obj.postal_code ? p_obj.postal_code : ''
      postal_code = street.length > 0 ? ', ' + postal_code : postal_code
      let city = p_obj.city ? p_obj.city : ''
      city = p_obj.postal_code.length > 0 ? ', ' + city : city
      this.dataForm.other_taxpayer.payer_address = street + postal_code + city
    },
  }
}
</script>

<style>
  .item_check {
    padding: 10px;
  }
  .item_check_desc {
    font-size: 12px;
    line-height:  12px;
    padding-left: 30px
  }
  .tool-tip-form {
    color:#409EFF;
    margin-left:7px;
    cursor:help;
  }
  .tool-tip-form:hover {
    color:#303133;
  }
</style>



// WEBPACK FOOTER //
// src/components/WebFormTaxPay/components/taxpay.vue